<template>
<div class="list_nbhd_outer">
  <div class="list_nbhd_inner">
    <div class="list_header">
      <el-checkbox :indeterminate="infoObj.isIndeterminate" v-model="infoObj.checked" @change="handleCheckAll">全选</el-checkbox>
      <div class="check_info">
        <div class="info_item">
          已选小区：
          <span class="num_info">
            <span class="checked_num">{{totalCheckedNbhd.length}}</span>/{{totalNbhdCount}}
          </span>
        </div>
        <div class="info_item">
          已选屏幕：
          <span class="num_info">
            <span class="checked_num">{{totalCheckedDevice.length}}</span>/{{totalDeviceCount}}
          </span>
        </div>
      </div>
    </div>
    <div class="list_box">
      <div v-if="showTab" class="shot_tab_bar">
        <MonitTabItem v-model="curTabName" :tabData="configTabs[0]">
          <template #default="{tab}">
            <div>
              {{ tab.title }}
              <span>({{deviceChecked.length}}/{{deviceCount}})</span>
            </div>
          </template>
        </MonitTabItem>
        <MonitTabItem v-model="curTabName" :tabData="configTabs[1]">
          <template #default="{tab}">
            <div>
              {{ tab.title }}
              <span>({{deviceOuterChecked.length}}/{{deviceOuterCount}})</span>
            </div>
          </template>
        </MonitTabItem>
      </div>
      <div
        v-show="curTabName === 'lift_inner'"
        ref="scrollInner"
        :class="['list_scroll_box', {'has_tab': showTab}]"
        @scroll.passive="scrollHandleIn">
        <!-- 处理本来就无数据的情况 -->
        <div v-if="!loading && isEmpty(nbhdList) && !searchKey" class="data_none">
          <img class="tip_img" src="../../assets/submit_fail.png" alt="温馨提示">
          <div class="tip_txt">{{noDataTip}}</div>
        </div>
        <div v-else>
          <div v-if="searchKey && isEmpty(showNbhds)" class="search_none">暂无结果，换个名称重新试试吧～</div>
          <el-collapse
            v-else
            v-model="activeNbhd"
            class="list_scroll_content"
            :style="paddinHolder">
            <MonitNbhd
              v-for="nbhd in showNbhds"
              :key="nbhd.nbhdName + nbhd.nbhdGuid"
              :curActive="activeNbhd"
              :transport.sync="nbhd"
              @check-change="checkHandle">
            </MonitNbhd>
          </el-collapse>
        </div>
      </div>
      <div
        v-show="curTabName === 'lift_outer'"
        ref="scrollOuter"
        :class="['list_scroll_box', {'has_tab': showTab}]"
        @scroll.passive="scrollHandleOut">
        <div v-if="!loading && isEmpty(nbhdOuterList) && !searchKey" class="data_none">
          <img class="tip_img" src="../../assets/submit_fail.png" alt="温馨提示">
          <div class="tip_txt">{{noDataTip}}</div>
        </div>
        <div v-else>
          <div class="search_none" v-if="searchKey && isEmpty(showOuterNbhds)">暂无结果，换个名称重新试试吧～</div>
          <el-collapse
            v-else
            v-model="activeOuterNbhd"
            class="list_scroll_content"
            :style="paddinHolderOut">
            <MonitNbhd
              v-for="nbhd in showOuterNbhds"
              :key="nbhd.nbhdName + nbhd.nbhdGuid"
              :curActive="activeOuterNbhd"
              :transport.sync="nbhd"
              @check-change="checkHandle">
            </MonitNbhd>
          </el-collapse>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { arrayChunk } from '@/utils/functions'
import MonitTabItem from './MonitTabItem'
import MonitNbhd from './MonitNbhd'
import ListMixin from './mixin/ListMixin'

// 单组小区数并不是越小性能越极致，须保证一组的高度能撑满整个容器才能保证列表滚动时无缝衔接
const groupCount = 10

// 单个小区的高度
const ItemMinH = 48

export default {
  name: 'NbhdList',
  components: { MonitTabItem, MonitNbhd },
  mixins: [ ListMixin ],
  props: {
    searchTxt: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    noDataTip: {
      type: String,
      default: '暂无数据'
    },
    showTab: { // 是否展示梯内屏&梯外屏tab栏
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchKey: '',
      configTabs: [
        { title:'梯内屏', name:'lift_inner' },
        { title:'梯外屏', name:'lift_outer' }
      ],
      curTabName: 'lift_inner',
      showNbhds: [], // 用于展示的小区列表
      activeNbhd: [], // 当前激活(展开)的小区面板(手风琴模式须为string，否则为array)
      showOuterNbhds: [], // 用于展示的梯外屏小区列表
      activeOuterNbhd: [],
      idxCur: 0, // 当前展示的小区列表所在小组的索引值
      idxOutCur: 0,
      paddinHolder: { // 小区列表占位padding
        paddingTop: '0px',
        paddingBottom: '0px'
      },
      paddinHolderOut: {
        paddingTop: '0px',
        paddingBottom: '0px'
      },
      totalCheckedNbhd: [],
      deviceChecked: [], // 梯内屏小区已勾选设备
      deviceOuterChecked: [] // 梯外屏小区已勾选设备
    }
  },
  computed: {
    nbhdList: { // 小区列表
      get () {
        // console.timeEnd('列表组件取得小区数据耗时')
        let inList = this.infoObj.subList[0].subList || []
        this.handleCheckNum()
        return this.searchKey ? inList.filter(el => el.nbhdName.indexOf(this.searchKey) > -1) : inList
      },
      set (arr) {}
    },
    chunckNbhd () { // 按每10个小区为一组进行分割后的数据数组
      return arrayChunk(this.nbhdList, groupCount)
    },
    nbhdOuterList: { // 梯外屏小区列表
      get () {
        let outList = this.infoObj.subList[1] ? (this.infoObj.subList[1].subList || []) : []
        return this.searchKey ? outList.filter(el => el.nbhdName.indexOf(this.searchKey) > -1) : outList
      },
      set (arr) {}
    },
    chunckOuterNbhd () {
      return arrayChunk(this.nbhdOuterList, groupCount)
    },
    totalNbhdCount () {
      let count = 0
      this.infoObj.subList.forEach(typeItem => {
        count += typeItem.subList.length
      })
      return count
    },
    deviceCount () {
      if (this.infoObj.subList[0]) return this.infoObj.subList[0].leafNodes.length
      return 0
    },
    deviceOuterCount () {
      if (this.infoObj.subList[1]) return this.infoObj.subList[1].leafNodes.length
      return 0
    },
    totalDeviceCount () {
      // console.log('梯内屏设备：', this.deviceCount)
      // console.log('梯外屏设备：', this.deviceOuterCount)
      return this.deviceCount + this.deviceOuterCount
    },
    totalCheckedDevice () {
      return this.deviceChecked.concat(this.deviceOuterChecked)
    }
  },
  watch: {
    infoObj (nv, ov) {
      this.listDataHandle()
    },
    searchTxt (keyStr, old) {
      this.searchKey = keyStr
      this.listDataHandle()
    }
  },
  destroyed () {
    this.infoObj = null
  },
  created () {
    this.listDataHandle()
  },
  // mounted () {
    // console.timeEnd('挂载小区列表')
    // this.$nextTick(() => {
    //   console.timeEnd('渲染小区列表')
    //   console.timeEnd('获得数据到小区列表渲染完成耗时')
    // })
  // },
  methods: {
    listDataHandle () { // 列表滚动懒加载
      this.idxCur = 0
      this.idxOutCur = 0
      let chunks = this.chunckNbhd
      if (chunks && chunks.length) {
        let list = chunks[this.idxCur]
        if (chunks.length > 1) list = list.concat(chunks[this.idxCur + 1])
        this.showNbhds = list
        this.calcListPadding()
      }
      let chunksOuter = this.chunckOuterNbhd
      if (chunksOuter && chunksOuter.length) {
        let outList = chunksOuter[this.idxOutCur]
        if (chunksOuter.length > 1) outList = outList.concat(chunksOuter[this.idxOutCur + 1])
        this.showOuterNbhds = outList
        this.calcOutListPadding()
      }
    },
    calcListPadding () {
      let topNum = this.idxCur * groupCount // 顶部数量必是10的整数倍
      if (topNum < 0) topNum = 0
      let bottomNum = this.nbhdList.length - this.showNbhds.length - topNum
      if (bottomNum < 0) bottomNum = 0
      this.paddinHolder = {
        paddingTop: topNum * ItemMinH + 'px',
        paddingBottom: bottomNum * ItemMinH + 'px'
      }
    },
    calcOutListPadding () {
      let topNum = this.idxOutCur * groupCount
      if (topNum < 0) topNum = 0
      let bottomNum = this.nbhdOuterList.length - this.showOuterNbhds.length - topNum
      if (bottomNum < 0) bottomNum = 0
      this.paddinHolderOut = {
        paddingTop: topNum * ItemMinH + 'px',
        paddingBottom: bottomNum * ItemMinH + 'px'
      }
    },
    scrollHandleIn () {
      let domScroll = this.$refs.scrollInner
      let sTop = domScroll.scrollTop

      let oneGroupH = ItemMinH * groupCount // 单组高度
      let idx = Math.floor(sTop / oneGroupH + 0.98) // 滚动距离只有稍微超过一组的高度即加载新的组
      // 展示第几组的开始索引 当idx值为：0->0~1, 1->0~1, 2->1~2, ...
      let sIdx = idx === 0 ? 0 : idx - 1
      const inChunks = this.chunckNbhd
      if (sIdx > inChunks.length - 2) sIdx = inChunks.length - 2
      if (sIdx === this.idxCur) return
      if (sIdx < 0) sIdx = 0 // 避免只有一组小区时出现sIdx为-1的情况
      this.idxCur = sIdx
      this.showNbhds = inChunks[sIdx + 1] ? inChunks[sIdx].concat(inChunks[sIdx + 1]) : inChunks[sIdx] // 第sIdx+1组是否存在,避免分组只有一组时越界
      this.calcListPadding()
    },
    scrollHandleOut () {
      let domScroll = this.$refs.scrollOuter
      let sTop = domScroll.scrollTop

      let oneGroupH = ItemMinH * groupCount
      let outIdx = Math.floor(sTop / oneGroupH + 0.98)
      let sIdx = outIdx === 0 ? 0 : outIdx - 1
      const outChunks = this.chunckOuterNbhd
      if (sIdx > outChunks.length - 2) sIdx = outChunks.length - 2
      if (sIdx === this.idxOutCur) return
      if (sIdx < 0) sIdx = 0
      this.idxOutCur = sIdx
      this.showOuterNbhds = outChunks[sIdx + 1] ? outChunks[sIdx].concat(outChunks[sIdx + 1]) : outChunks[sIdx]
      this.calcOutListPadding()
    },
    handleCheckAll (val) { // 全选所有小区的所有设备
      console.log('全选：', val)
      console.time('全选处理耗时')
      this.changeItemStatus(this.infoObj, val)
      console.timeEnd('全选处理耗时')
    },
    emitChooseInfo () { // 传递截图用小区及设备勾选信息到父级组件
      let info = {
        deviceGuids: this.totalCheckedDevice,
        nbhdCount: this.totalCheckedNbhd.length,
        screenCount: this.totalCheckedDevice.length
      }
      this.$emit('submitMonit', info)
    },
    checkHandle () {
      this.checkChange()
      this.handleCheckNum()
      this.$forceUpdate()
    },
    handleCheckNum () {
      const inOutArr = this.infoObj.subList
      let arr = []
      inOutArr.forEach(typeItem => {
        arr = arr.concat(typeItem.subList.filter(el => el.checked || el.isIndeterminate))
      })
      this.totalCheckedNbhd = arr

      this.deviceChecked = inOutArr[0].leafNodes.filter(el => el.checked).map(t => t.deviceGuid)
      if (inOutArr[1]) {
        this.deviceOuterChecked = inOutArr[1].leafNodes.filter(el => el.checked).map(t => t.deviceGuid)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.list_nbhd_outer {
  background: #fff;
  height: calc(100% - 40px);
  overflow: hidden;
  .list_nbhd_inner {
    height: 100%;
  }
  ::v-deep .el-checkbox .el-checkbox__inner::after {
    transition: none !important;
  }
}
.list_header {
  border: 1px solid #E9E9E9;
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
  ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #282729;
  }
  .check_info {
    float: right;
    color: #999;
    .info_item {
      display: inline-block;
      &:not(:last-child) {
        margin-right: 20px;
      }
    }
    .num_info {
      color: #282729;
    }
    .checked_num {
      color: #FF3973;
    }
  }
}
.list_box {
  border-left: 1px solid #E9E9E9;
  border-right: 1px solid #E9E9E9;
  width: 100%;
  height: calc(100% - 50px);
  padding: 10px 10px 0;
  .shot_tab_bar {
    background: #F5F5F5;
    border: 1px solid #E9E9E9;
    border-radius: 4px;
    height: 30px;
    line-height: 30px;
    .tab-item {
      display: inline-block;
      background: #fff;
      border-right: 1px solid #E9E9E9;
      cursor: pointer;
      min-width: 150px;
      height: 100%;
      padding: 0 6px;
      text-align: center;
      &.disable {
        cursor: not-allowed;
      }
      &:not(.cur) {
        color: #999;
      }
      &:nth-of-type(1) {
        border-radius: 4px 0 0 4px;
      }
      &:nth-of-type(2) {
        border-radius: 0 4px 4px 0;
      }
    }
  }
  .list_scroll_box {
    height: 100%;
    position: relative;
    overflow: hidden auto;
    &.has_tab {
      height: calc(100% - 30px);
      padding-top: 10px;
    }
    .data_none {
      color: #999;
      width: 100%;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      text-align: center;
      .tip_img {
        width: 93px;
        height: 75px;
        margin-bottom: 20px;
      }
      .tip_txt {
        width: 628px;
        margin: 0 auto;
      }
    }
    .search_none {
      background: #F5F5F5;
      border-radius: 4px;
      color: #999;
      font-size: 14px;
      width: 100%;
      height: 62px;
      line-height: 62px;
      text-align: center;
    }
    .list_scroll_content {
      padding: 0 20px 0 15px;
      border: 1px solid #e9e9e9;
      border-radius: 4px;
      margin-bottom: 10px;
      ::v-deep .el-collapse-item__content {
        padding-bottom: 10px;
      }
    }
  }
}
</style>
